import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from "typeorm";
import { CommonColumns } from "./common-columns.entity";
import { Question } from "./question.entity";

@Entity()
export class QuestionOption extends CommonColumns {

  @ManyToOne(() => Question, question => question.questionOptions, { nullable: false, })
  @JoinColumn({ name: 'question_id', referencedColumnName: 'id', })
  question: Question;

  // 敢えて表示名とValueを分けない
  @Column({ name: 'option_text', })
  optionText: string;

  @Column({ name: 'disp_order', })
  dispOrder: number;

  @Column({ name: 'with_free_text', default: false, })
  withFreeText: boolean;

  @Column({ name: 'free_text_placeholder', default: '', })
  freeTextPlaceholder: string;

  @Column({ name: 'free_text_required', default: false, })
  freeTextRequired: boolean;

  constructor(props: TQuestionOption) {
    super();
    Object.assign(this, props);
  }
}

export declare type TQuestionOption = Omit<QuestionOption, 'dummy-no-such-field'>;
export interface IQuestionOption extends TQuestionOption {};
